import React from 'react';

const BankAccount = ({ ban }) => {
    if (!ban) {
        return null;
    }

    if (ban.match(/[0-9]{12}/)) {
        const parts = ban.match(/(?<sort1>[0-9]{2})(?<sort2>[0-9]{2})(?<sort3>[0-9]{2})(?<account>[0-9]{8})/);

        return <>SC: {parts.groups.sort1}-{parts.groups.sort2}-{parts.groups.sort3} | AN: {parts.groups.account}</>
        // GB38MONZ04000433388223

    } else if (ban.match(/GB[0-9a-zA-Z]+[0-9]{12}/)) {
        const parts = ban.match(/.*(?<sort1>[0-9]{2})(?<sort2>[0-9]{2})(?<sort3>[0-9]{2})(?<account>[0-9]{8})$/);

        return <>SC: {parts.groups.sort1}-{parts.groups.sort2}-{parts.groups.sort3} | AN: {parts.groups.account}</>
    } else {
        return ban;
    }
}

export default BankAccount;